import { render } from "./PrimaryButton.vue?vue&type=template&id=bfaad2f8"
const script = {}

import exportComponent from "/var/www/vhosts/packperform.com/httpdocs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__